export var getAddressLink = function getAddressLink(explorerUrl) {
  return function (address) {
    return "".concat(explorerUrl, "/address/").concat(address);
  };
};
export var getTransactionLink = function getTransactionLink(explorerUrl) {
  return function (txnId) {
    return "".concat(explorerUrl, "/tx/").concat(txnId);
  };
};